/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_SCHEDULED_MESSAGES,
  GET_SCHEDULED_MESSAGES_SUCCESS,
  GET_SCHEDULED_MESSAGES_ERROR,
  REMOVE_SCHEDULED_MESSAGES,
  REMOVE_SCHEDULED_MESSAGES_SUCCESS,
  REMOVE_SCHEDULED_MESSAGES_ERROR,
  REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE,
  REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE_SUCCESS,
  REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE_ERROR,
  ADD_CONTACTS_SCHEDULED_MESSAGES,
  ADD_CONTACTS_SCHEDULED_MESSAGES_SUCCESS,
  ADD_CONTACTS_SCHEDULED_MESSAGES_ERROR,
  UPDATE_CONTACTS_SCHEDULED_MESSAGES,
  UPDATE_CONTACTS_SCHEDULED_MESSAGES_SUCCESS,
  UPDATE_CONTACTS_SCHEDULED_MESSAGES_ERROR,
  REMOVE_CONTACTS_SCHEDULED_MESSAGES,
  REMOVE_CONTACTS_SCHEDULED_MESSAGES_SUCCESS,
  REMOVE_CONTACTS_SCHEDULED_MESSAGES_ERROR,
  SET_SCHEDULED_MESSAGES,
  GET_FOLLOW_UP_MESSAGES,
  GET_FOLLOW_UP_MESSAGES_SUCCESS,
  GET_FOLLOW_UP_MESSAGES_ERROR,
  SET_SCHEDULED_MESSAGES_QUERY,
  CLEAR_SCHEDULED_MESSAGES_QUERY_FILTER,
  SET_SELECTED_SCHEDULED_MESSAGES,
  SET_VALUES_FORM_SEND_TEXT,
  SEND_TEXT_MESSAGE,
  SEND_TEXT_MESSAGE_SUCCESS,
  SEND_TEXT_MESSAGE_ERROR,
  SET_BACK_TO_SCHEDULED_MESSAGES_LIST,
  SET_BACK_TO_SCHEDULED_MESSAGE_EDIT,
  SET_SCHEDULED_MESSAGE_DETAILS_TAB,
  GET_SCHEDULED_MESSAGE_CONTACTS,
  GET_SCHEDULED_MESSAGE_CONTACTS_SUCCESS,
  GET_SCHEDULED_MESSAGE_CONTACTS_ERROR,
  SET_CONTACTS_SEND_TO_QUERY,
  SET_CONTACTS_DONT_SEND_TO_QUERY,
  SET_SELECTED_CONTACTS_SEND_TO,
  SET_SELECTED_CONTACTS_DONT_SEND_TO,
  CLEAR_SCHEDULED_MESSAGE_CONTACTS,
  SOCKET_SCHEDULED_MESSAGE_SENT_LIST,
  GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY,
  GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY_SUCCESS,
  GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY_ERROR,
} from 'src/actions/scheduledMessagesActions';

const initialFilters = {
  messageType: null,
  dateFrom: null,
  dateTo: null,
  eventsToSelect: [],
  groupsToSelect: [],
};

const formSendText = {
  systemGenMessageReplaced: false,
  attachment: false,
  attachmentContainer: null,
  loading: false,
};

const followUpMessages = {
  followUpMessageList: [],
  loading: false,
};

const backToScheduledMessagesList = {
  scheduledMessages: [],
  query: {},
  active: false,
  comeBack: false,
  backToId: null,
  initScrollToId: false,
};
const backToScheduledMessageEdit = {
  active: false,
  comeBack: false,
  scheduledMessageId: null,
  isSmartActionDirectLink: false,
};

const sendToQuery = {
  search: '',
  sort: [['name', 'asc']],
  page: 1,
  pageSize: 25,
  count: 0,
};

const dontSendToQuery = {
  search: '',
  sort: [['name', 'asc']],
  page: 1,
  pageSize: 25,
  count: 0,
};

const sendTo = {
  loading: false,
  hiddenUpdatingLoading: false,
  totalCountLoading: false,
  totalCount: 0,
  contacts: [],
  selectedContacts: [],
  query: sendToQuery,
};

const dontSendTo = {
  loading: false,
  hiddenUpdatingLoading: false,
  totalCountLoading: false,
  totalCount: 0,
  contacts: [],
  selectedContacts: [],
  query: dontSendToQuery,
};

const initialState = {
  scheduledMessages: [],
  selectedScheduledMessages: [],
  query: {
    status: 'scheduled',
    search: '',
    filters: initialFilters,
    sort: [['dateTime', 'asc']],
    page: 1,
    pageSize: 50,
    count: 0,
  },
  formSendText,
  followUpMessages,
  backToScheduledMessagesList,
  backToScheduledMessageEdit,
  currentNavigationTab: 'details',
  loading: false,
  recipientsLoading: false,
  sendTo,
  dontSendTo,
  contactsSummary: null,
  contactsSummaryLoading: false,
};

const scheduledMessagesReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_SCHEDULED_MESSAGES: {
      return produce(state, (draft) => {
        draft.scheduledMessages = payload || [];
        draft.selectedScheduledMessages = [];
      });
    }

    case GET_SCHEDULED_MESSAGES:
    case REMOVE_SCHEDULED_MESSAGES: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_SCHEDULED_MESSAGES_SUCCESS: {
      return produce(state, (draft) => {
        draft.scheduledMessages = payload?.data || [];
        draft.query.count = payload?.count || 0;
        draft.loading = false;
        draft.selectedScheduledMessages = [];
      });
    }

    case GET_SCHEDULED_MESSAGES_ERROR:
    case REMOVE_SCHEDULED_MESSAGES_SUCCESS:
    case REMOVE_SCHEDULED_MESSAGES_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case SET_SCHEDULED_MESSAGES_QUERY: {
      return produce(state, (draft) => {
        draft.query = payload ? {
          ...state.query,
          ...payload
        } : initialState.query;
      });
    }

    case CLEAR_SCHEDULED_MESSAGES_QUERY_FILTER: {
      return produce(state, (draft) => {
        draft.query.filters = initialFilters;
        draft.query.page = initialState.query.page;
      });
    }

    case SET_SELECTED_SCHEDULED_MESSAGES: {
      return produce(state, (draft) => {
        draft.selectedScheduledMessages = payload || [];
      });
    }

    case SET_VALUES_FORM_SEND_TEXT: {
      return produce(state, (draft) => {
        draft.formSendText = payload ? {
          ...state.formSendText,
          ...payload,
        } : formSendText;
      });
    }

    case SEND_TEXT_MESSAGE: {
      return produce(state, (draft) => {
        draft.formSendText.loading = true;
      });
    }

    case SEND_TEXT_MESSAGE_SUCCESS:
    case SEND_TEXT_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.formSendText.loading = false;
      });
    }

    case GET_FOLLOW_UP_MESSAGES: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = true;
      });
    }

    case GET_FOLLOW_UP_MESSAGES_SUCCESS:
    case GET_FOLLOW_UP_MESSAGES_ERROR: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = false;
        draft.followUpMessages.followUpMessageList = payload ? [
          ...state.followUpMessages.followUpMessageList,
          ...payload,
        ] : followUpMessages.followUpMessageList;
      });
    }

    case SET_BACK_TO_SCHEDULED_MESSAGES_LIST: {
      return produce(state, (draft) => {
        draft.backToScheduledMessagesList = payload ? {
          ...state.backToScheduledMessagesList,
          ...payload,
        } : backToScheduledMessagesList;
      });
    }

    case SET_BACK_TO_SCHEDULED_MESSAGE_EDIT: {
      return produce(state, (draft) => {
        draft.backToScheduledMessageEdit = payload ? {
          ...state.backToScheduledMessageEdit,
          ...payload,
        } : backToScheduledMessageEdit;
      });
    }

    case SET_SCHEDULED_MESSAGE_DETAILS_TAB: {
      return produce(state, (draft) => {
        draft.currentNavigationTab = payload || initialState.currentNavigationTab;
      });
    }

    case REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE: {
      return produce(state, (draft) => {
        draft.formSendText.loading = true;
      });
    }

    case REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE_SUCCESS:
    case REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.formSendText.loading = false;
        draft.formSendText.systemGenMessageReplaced = payload || false;
      });
    }

    case ADD_CONTACTS_SCHEDULED_MESSAGES:
    case REMOVE_CONTACTS_SCHEDULED_MESSAGES:
    case UPDATE_CONTACTS_SCHEDULED_MESSAGES: {
      return produce(state, (draft) => {
        draft.recipientsLoading = true;
      });
    }

    case ADD_CONTACTS_SCHEDULED_MESSAGES_SUCCESS:
    case ADD_CONTACTS_SCHEDULED_MESSAGES_ERROR:
    case REMOVE_CONTACTS_SCHEDULED_MESSAGES_SUCCESS:
    case REMOVE_CONTACTS_SCHEDULED_MESSAGES_ERROR:
    case UPDATE_CONTACTS_SCHEDULED_MESSAGES_SUCCESS:
    case UPDATE_CONTACTS_SCHEDULED_MESSAGES_ERROR: {
      return produce(state, (draft) => {
        draft.recipientsLoading = false;
      });
    }

    case GET_SCHEDULED_MESSAGE_CONTACTS: {
      const {
        isSendTo,
        isOnlyTotalCount,
        hiddenUpdating,
      } = payload || {};
      return produce(state, (draft) => {
        const keyForSending = isSendTo ? 'sendTo' : 'dontSendTo';

        if (hiddenUpdating) {
          draft[keyForSending].hiddenUpdatingLoading = true;
          return;
        }
        // draft.recipientsLoading = true;
        if (isOnlyTotalCount) {
          draft[keyForSending].totalCountLoading = true;
          return;
        }
        draft[keyForSending].loading = true;
      });
    }

    case GET_SCHEDULED_MESSAGE_CONTACTS_SUCCESS: {
      const {
        isSendTo,
        isOnlyTotalCount,
        contacts,
        hiddenUpdating,
      } = payload || {};
      const contactsData = contacts?.data || [];

      return produce(state, (draft) => {
        const keyForSending = isSendTo ? 'sendTo' : 'dontSendTo';

        if (hiddenUpdating) {
          draft[keyForSending].hiddenUpdatingLoading = false;
          draft[keyForSending].contacts = (state?.[keyForSending]?.contacts || []).map((contact) => {
            const newContact = contactsData.find((item) => item?.id && item?.id === contact?.id);
            return {
              ...newContact || contact || {},
            };
          });
          return;
        }
        // draft.recipientsLoading = false;
        if (isOnlyTotalCount) {
          draft[keyForSending].totalCountLoading = false;
          draft[keyForSending].totalCount = contacts?.count || 0;
          return;
        }
        draft[keyForSending].loading = false;
        draft[keyForSending].contacts = contactsData;
        draft[keyForSending].totalCount = contacts?.count || 0;
        draft[keyForSending].query = {
          ...state[keyForSending].query,
          page: contacts?.page || 1,
          count: contacts?.count || 0,
        };
      });
    }

    case GET_SCHEDULED_MESSAGE_CONTACTS_ERROR: {
      const {
        isSendTo,
        isOnlyTotalCount,
        hiddenUpdating,
      } = payload || {};
      return produce(state, (draft) => {
        const keyForSending = isSendTo ? 'sendTo' : 'dontSendTo';

        if (hiddenUpdating) {
          draft[keyForSending].hiddenUpdatingLoading = false;
          return;
        }
        // draft.recipientsLoading = false;
        if (isOnlyTotalCount) {
          draft[keyForSending].totalCountLoading = false;
          return;
        }
        draft[keyForSending].loading = false;
      });
    }

    case CLEAR_SCHEDULED_MESSAGE_CONTACTS: {
      return produce(state, (draft) => {
        draft.sendTo = sendTo;
        draft.dontSendTo = dontSendTo;
      });
    }

    case SET_SELECTED_CONTACTS_SEND_TO: {
      return produce(state, (draft) => {
        draft.sendTo.selectedContacts = payload || [];
      });
    }

    case SET_SELECTED_CONTACTS_DONT_SEND_TO: {
      return produce(state, (draft) => {
        draft.dontSendTo.selectedContacts = payload || [];
      });
    }

    case SET_CONTACTS_SEND_TO_QUERY: {
      return produce(state, (draft) => {
        draft.sendTo.query = payload ? {
          ...state.sendTo.query,
          ...payload
        } : initialState.sendTo.query;
      });
    }

    case SET_CONTACTS_DONT_SEND_TO_QUERY: {
      return produce(state, (draft) => {
        draft.dontSendTo.query = payload ? {
          ...state.dontSendTo.query,
          ...payload
        } : initialState.dontSendTo.query;
      });
    }

    case SOCKET_SCHEDULED_MESSAGE_SENT_LIST: {
      return produce(state, (draft) => {
        const {
          id: scheduledMessageId,
          messageType: scheduledMessageType,
          sentMessagesCount: scheduledMessageSentMessagesCount,
          contactsToSendTotalCount: scheduledMessageContactsToSendTotalCount,
          contactsNotToSendTotalCount: scheduledMessageContactsNotToSendTotalCount,
          contactsCount: scheduledMessageContactsCount,
          isSending: scheduledMessageIsSending = false,
        } = payload || {};

        draft.scheduledMessages = scheduledMessageId && scheduledMessageType ? state.scheduledMessages?.map((scheduledMessage) => {
          if (scheduledMessageId !== scheduledMessage?.id
            || scheduledMessageType !== scheduledMessage?.messageType) {
            return scheduledMessage;
          }

          return {
            ...scheduledMessage || {},
            sentMessagesCount: scheduledMessageSentMessagesCount,
            isSending: scheduledMessageIsSending,
            contactsToSendTotalCount: scheduledMessageContactsToSendTotalCount,
            contactsNotToSendTotalCount: scheduledMessageContactsNotToSendTotalCount,
            contactsCount: scheduledMessageContactsCount,
            isProbablySent: !!(!scheduledMessageIsSending && scheduledMessage?.isSending),
          };
        }) || [] : state.scheduledMessages;
      });
    }

    case GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY: {
      return produce(state, (draft) => {
        draft.contactsSummaryLoading = true;
      });
    }

    case GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY_SUCCESS: {
      return produce(state, (draft) => {
        draft.contactsSummaryLoading = false;
        draft.contactsSummary = payload || null;
      });
    }

    case GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY_ERROR: {
      return produce(state, (draft) => {
        draft.contactsSummaryLoading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default scheduledMessagesReducer;
